import { ReactComponent as PlusIcon } from "./../../../../assets/svg/plus.svg";
import { ReactComponent as MinusIcon } from "./../../../../assets/svg/minus.svg";
import { ReactComponent as TrashIcon } from "./../../../../assets/svg/trash.svg";
import { Spin } from "antd";
import styles from "./Plum.module.css";

const Plum = ({ disabled, increment, decrement, trash, children }) => {
  return (
    <div className={`${styles.ChangeNumberContainer}`}>
      <button
        disabled={disabled}
        onClick={decrement}
        className={styles.PlumButton}
      >
        {trash ? (
          <TrashIcon className={styles.TrashIcon} />
        ) : (
          <MinusIcon className={styles.MinusIcon} />
        )}
      </button>
      <div className={styles.ChangeNumberText}>
        {disabled ? <Spin size="small" /> : children}
      </div>
      <button
        disabled={disabled}
        onClick={increment}
        className={styles.PlumButton}
      >
        <PlusIcon className={styles.PlusIcon} />
      </button>
    </div>
  );
};

export default Plum;
